import { ReactNode } from "react"
import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons' 
import { FusionColor } from "../../../theme/FusionStyle"
import { Theme } from "@emotion/react"
import { TIP_FONT_SIZE } from "../l1/L1Tip"

type NoticeGridProps = {
	outline?: boolean
} & { theme: Theme}

const NoticeGrid = styled.div(({theme, outline = true}: NoticeGridProps) => ({
	border: `1px solid ${outline ? theme.colors.lines : theme.colors.transparent}`,
	borderRadius: theme.borderRadius,
	display: 'grid',
	gridTemplateColumns: 'max-content 1fr',
	padding: theme.spacing(2),
	gap: theme.spacing(2),
}))

type IconContainerProps = {
	color?: FusionColor
} & { theme: Theme }

const IconContainer = styled.div(({theme, color = FusionColor.BlueMain}: IconContainerProps) => ({
	alignSelf: 'start',
	marginTop: '2px',  // nudge it to look better with the text
	color: theme.colors[color],
	fontSize: TIP_FONT_SIZE,
}))

interface L2NoticeProps {
	outline?: boolean
	color?: FusionColor
	children: ReactNode
}

const L2Notice = ({outline, color, children}: L2NoticeProps) => {
	return (
		<NoticeGrid outline={outline}>
			<IconContainer color={color}>
				<FontAwesomeIcon icon={faCircleInfo} />
			</IconContainer>
			<div>
				{children}
			</div>
		</NoticeGrid>
	)
}

export default L2Notice
